import { HomeTranslation } from 'locales/de/pages/home';

const en: HomeTranslation = {
  title: 'Home',
  editMode: 'Editmode',
  systemTilesTitle: 'System tiles',
  customTilesTitle: 'Individual tiles',
  notSaveMessage: 'Unsaved changes will be lost when leaving the page!',
  viewAll: 'View all',
  cardDrawer: {
    drawerTitle: 'Create new card',
    predefinedDrawerTitle: 'Add new tile',
    defaultIconDrawerTitle: 'Select a predefined icon for your tile',
    drawerCreateSystemTitle: 'Create new system-card',
    drawerEditSystemTitle: 'Edit system-card',
    title: 'Title',
    titleEN: 'Title (Englisch)',
    link: 'Link',
    styleType: 'Special styling',
    moreOptions: 'More options',
    lessOptions: 'Less options',
    shortText: 'Short description',
    shortTextEN: 'Short description (English)',
    tileIcon: 'Tile-Icon',
    external: 'Is the link an external page?',
    notInNavInfo: 'The tile does not appear in the navigation bar but is only on the dashboard.',
    roundImage: 'Should the picture be rounded off?',
    visibilityGroups: 'Visibility Groups',
    createOwnTile: 'Create custom tile',
    info: 'Choose a predefined tile or create a custom one.',
    defaultIcons: 'Choose icon',
    noDefaultTiles: 'There are no predefined tiles yet. Create your own tile instead.',
    noDefaultIcons: 'There are no predefined icons yet.',
    systemTile: 'System-Tile',
    defaultTile: 'Predefined-Tile',
    tooltips: {
      systemTile:
        'System tiles cannot be removed by the user and are therefore fixed for the selected user groups.',
      defaultTile:
        'Predefined tiles can be selected by users as required and added to their own dashboard.',
      externalLinkTip: 'Open link in new Tab.'
    },
    placeholder: {
      title: 'Tile name',
      description: 'Tile description',
      uploadImage: 'Upload icon'
    }
  },
  alerts: {
    successfulCreate: 'The tile has been created.',
    successfulUpdate: 'The tile has been updated.',
    successfulRemove: 'The tile has been removed.',
    failedCreate: 'The tile could not be created.',
    failedUpdate: 'The tile could not be updated.',
    failedRemove: 'The tile could not be removed.',
    failedUpload: 'The icon could not be uploaded.'
  },
  dialog: {
    deleteConfirm: {
      title: 'Really remove?',
      message:
        'If it is a predefined tile, it can be added again at any time.\n However, if it is a self-created custom tile, it will be deleted.'
    },
    cancelEditMode: {
      title: 'Really close?',
      message: 'Confirmation resets every change'
    }
  },
  jobmarket: 'Job Market',
  timeTable: {
    title: 'Timetable',
    description: 'Here is the timetable for your courses'
  },
  onlineServiceCenter: {
    title: 'Online-Service-Center',
    description: 'Registration for exams and access to grades'
  },
  safetyAndHealth: {
    title: 'Occupational safety and health',
    description: 'Occupational safety and health at the TH Rosenheim'
  },
  documentResearch: {
    title: 'Document Research',
    description: 'DMS-System of the TH Rosenheim'
  },
  primion: {
    title: 'Primion',
    description: 'Portal for Working Time Management (VPN necessary)'
  },
  employeePortal: {
    title: 'Employee Portal',
    description: 'Business trips, salary statements etc.'
  },
  incomings: {
    description: 'Management tool for visiting students'
  },
  learningCampus: {
    title: 'Learning Campus',
    description: 'E-Learning-Campus of TH Rosenheim'
  },
  openCast: {
    title: 'OpenCast Videos',
    description: 'Video platform of TH Rosenheim'
  },
  acquisition: {
    title: 'Acquisition',
    description: 'Internal procurement of the TH Rosenheim'
  },
  announcements: {
    title: 'Announcements',
    description: 'The newest announcements in your community'
  },
  bulletin: {
    title: 'Bulletin Board',
    description: "Look at what's being offered"
  },
  company: {
    description: 'Edit your company data & manage your job offers',
    maintenance: 'The jobmarket ist under maintenance',
    maintenanceTitle: 'Maintenance'
  },
  ioCourses: {
    title: 'Courses',
    description: 'Course registration for exchange students / International Office'
  },
  ioEvents: {
    title: 'Events',
    description: 'Event registration for international students / International Office'
  },
  ioUsers: {
    title: 'User',
    description: 'Here you can find all users of the International Office'
  },
  articlesList: {
    heading: 'Events and Announcements',
    today: 'Today',
    further: 'Further Events and Announcements'
  },
  phoneList: {
    title: 'Phone List',
    description: 'Find all contacts here'
  },
  calendar: {
    heading: 'Calendar',
    event: 'Event',
    general: 'General',
    study: 'Study',
    legal: 'Legal',
    holiday: 'Holiday',
    action: 'View calender'
  },
  watchlist: {
    heading: 'Watchlist',
    action: 'View all',
    alreadyAdded: 'Already in Watchlist',
    empty: 'Nothin to watch yet',
    deleteError: 'Error while removing from Watchlist',
    deleteSuccess: 'Successfully removed from Watchlist',
    addSuccess: 'Successfully added to Watchlist',
    addError: 'Error while adding to Watchlist'
  },
  notifications: {
    heading: 'Notifications'
  },
  syncShare: {
    title: 'Sync + Share',
    description: 'Here you can get to the Sync + Share of the TH Rosenheim'
  },
  library: {
    title: 'OPAC',
    descriptionPart1: 'Library',
    descriptionPart2: 'E-books usable via VPN client'
  },
  activityLog: {
    title: 'Activity Log',
    description: 'View recent activities'
  },
  events: {
    title: 'Events',
    description: 'View all events'
  },
  fundings: {
    title: 'Fundinginformation',
    description: 'Here you can get information about the latest fundingprograms'
  },
  leihBar: {
    title: 'leihBar',
    description: 'Here you can borrow articles and book rooms'
  },
  formsIntern: {
    title: 'Portal for Semester of leave',
    description: 'Submit applications for leave of absence (e.g. research semester)'
  },
  vhb: {
    title: 'VHB-Courses',
    description: 'Registration for VHB-Courses',
    dialog: {
      title: 'Registration for VHB-Courses',
      confirmButton: 'Go to vhb.org',
      information: `Register with the vhb at www.vhb.org with your student email address (max.mustermann@stud.th-rosenheim.de) or log back there if you have already taken a course.
      
      Then register for your corresponding course at www.vhb.org.
      Course registrations are usually available from 15/03 or 01/10.
      
      Further information about credits in the respective faculties at TH Rosenheim: `
    }
  }
};

export default en;
